import { toastNotify } from "./Helper";

export const ENDPOINT = process.env.REACT_APP_ENDPOINT;

// Desi Movies
export const GET_ALL_DESI_MOVIES = `get-all-desi-movies`;
export const GET_DESI_MOVIE_BY_ID = `get-desi-movie-by-id/`;
export const GET_DESI_MOVIE_COMMENT_BY_ID = `desi-movie-comment-by-id/`;
export const POST_DESI_MOVIE_COMMENTS = `desi-movie-comment/`;

// Forum
export const GET_ALL_HOME_FORUM = `get-forum-data`;
export const CREATE_FORUM = `create-forum`;
export const GET_ALL_FORUM_CATEGORIES = `get-all-forum-category`;
export const GET_ALL_FORUM_LIST_BY_CATEGORY_ID = `get-all-forum-list-by-category-id`;
export const GET_FORUM_BY_ID = `get-forum-by-id`;
export const SEARCH_FORUM = `search-forum/`;
export const POST_FORUM_COMMENT = `comment-forum/`;
export const GET_SUB_CAT_BY_CAT_ID = `get-all-subsub-category-under-sub-category`;
export const GET_FORUM_SUB_CATEGORY = `get-all-forum-sub-category-by-id`;
export const   POST_FORUM_REPLY = `reply-forum-comment`;

// Nris Talk
export const GET_ALL_NRIS_TALK = `get-all-nris-talk`;
export const GET_ALL_NRIS_TALK_LIST = `get-all-nris-talk-list`;
export const GET_NRI_TALK_BY_ID = `get-nris-talk`;
export const SEARCH_NRI_TALK = `search-nris-talk`;
export const POST_NRI_COMMENT = `create-nris-talk-reply`;
export const UPDATE_NRIS_VIEW = `update-nris-talk-view`;
export const CREATE_NRI_TALK = `create-nris-talk`;
export const   POST_NRIS_TALK_REPLY = `create-nris-talk-ads-reply`;

// Ads
export const GET_PREMIMUN_ADS = `get-premium-ads-list`;
export const GET_ALL_GIF_ADS = `get-gif-ads/`;
export const GET_CLASSIFIED_ADS_BY_CATEGORY = `get-free-ads-by-category/`;
export const RECENT_ADS = `get-recent-ads-list/`;
export const CREATE_CLASSIFIED_ADS = `create-free-clasified`;
export const GET_ALL_SUB_CAT_BY_CAT_ID = `get-all-sub-category-by-id`;

// Header menu link
export const GET_CARPOOL_LIST = `get-all-carpool-category/`;
export const GET_ALL_CATEGORIES = `get-all-category/`;
export const GET_BUSINESS_CATEGORIES = `get-business-list-by-category/`;

// Country & State
export const GET_ALL_COUNTRY = `get-all-country/`;
export const GET_ALL_STATE_BY_NAME = `get-all-states-by-names/`;
export const GET_ALL_STATE_BY_COUNTY_ID = `get-all-state-by-country/`;

// Movies
export const GET_ALL_MOVIE_RATING = `get-all-movie-ratings/`;
export const GET_ALL_MOVIE_RESOURCE = `get-all-source/`;
export const GET_MOVIE_LANGUAGES = `get-all-movie-video-language/`;
export const GET_ALL_MOVIE_CATEGORIES = `get-all-movie-video-category/`;
export const GET_ALL_MOVIE_BY_CAT_LANG_ID = `get-all-movie-video-by-category-language-id/`;
export const GET_MOVIE_RATING_BY_ID = `get-movie-rating-by-id/`;
export const GET_ALL_MOVIES = `get-all-movie-video/`;
export const SEARCH_MOVIES = `search-movie-video/`;
export const MOVIE_DISLIKE = `movie-video-dislike`;
export const MOVIE_LIKE = `movie-video-like`;
export const MOVIE_RATING = `user-movie-ratings`;

// News
export const GET_ALL_NEWS = `get-homepage-news/`;
export const GET_NEWS_BY_ID = `get-news-by-id/`;

// Events
export const GET_EVENTS_CATEGORIES = `get-all-events-category/`;
export const GET_ALL_EVENTS_BY_CAT_ID = `get-all-events-list-by-category-id/`;
export const GET_EVENT_BY_ID = `get-event-by-id/`;
export const POST_EVENT_COMMENT = `comment-event-list/`;

// Traning
export const GET_TRANING_CATETORIES = `get-all-training-category/`;
export const GET_ALL_TRANING_BY_CAT_ID = `get-all-training-list-by-category-id/`;
export const GET_ALL_TRANING = `get-all-training-palcement/`;
export const GET_ALL_STUDENT_TALK = `get-student-talk-by-category/`;
export const GET_TRANING_BY_ID = `get-training-by-id`;
export const POST_TRANING_COMMENT = `comment-training-list/`;

// Blogs
export const GET_HOMEPAGE_BLOG = `get-homepage-blog`;
export const GET_ALL_BLOG = `get-all-blog`;
export const GET_BLOG_BY_ID = `get-blog-by-id/`;
export const POST_BLOG_COMMENT = `blog-comment/`;
export const BLOG_LIKE = `blog-view`;
export const   POST_BLOG_REPLY = `blog-reply`;


// Carpool
export const GET_CARPOOL_BY_CATEGORY_ID = `get-all-carpool-list-by-category-id/`;
export const CREATE_CARPOOL = `create-carpool/`;
export const POST_CARPOOL_REPLY = `create-carpool-reply/`;
export const POST_CARPOOL_COMMENT = `comment-carpool/`;
export const GET_CARPOOL_BY_ID = `get-carpool-by-id/`;

// Business
export const GET_ALL_BUSINESS_BY_CAT_ID = `get-all-business-list-by-category-id/`;
export const GET_BUSINESS_BY_ID = `get-business-by-id/`;
export const SEARCH_BUSINESS_LISTING = `search-business-listing/`;

// Real Estate
export const GET_FREE_CLASSIFIED_BY_ID = `get-free-clasified-by-id/`;
export const SEARCH_FREE_ADS = `search-free-ads/`;
export const POST_CLASSIFIED_COMMENT = `create-free-clasified-comment/`;
export const   POST_CLASSIFIED_REPLY = `create-free-clasified-reply/`;


// Student Talk
export const GET_STUDENT_TALK_BY_ID = `get-student-talk-by-id/`;
export const POST_STUDENT_TALK_COMMENT = `comment-student-talk/`;
export const GET_STUDENT_TALK_CAT = `get-all-student-talk-category/`;
export const ADD_UNIVERSITY = `add-student-university/`;
export const GET_ALL_UNIVERSITY = `get-all-university/`;
export const CREATE_STUDENT_TALK = `create-student-talk/`;
export const POST_STUDENT_TALK_REPLY = `reply-student-talk`;

// Search
export const COUNTRY_SEARCH = `country-search/`;
export const STATE_SEARCH = `state-search/`;
export const SUBSCRIBE_US = `subscribe-us`;
export const CREATE_ADVERTISE_WITH_US = `create-advertise-with-us/`;

// City
export const GET_CITY_BY_STATE_ID = `get-all-city-by-stateId`;
export const GET_CITY_STATE_AND_COUNTRY_ID = `get-all-city-by-state-and-country/`;

// Contact Us
export const CONTACT_US = `contact-us`;

// Notification
export const NOTIFICATION = `recent-notification`;

// updateFreeClassifieds = `update-free-clasified/`;
// editFreeClassifieds = `edit-free-clasified/`;
// getMovieVideoByCategory = `get-movie-video-by-category/`;
// getMovieVideoByLanguage = `get-movie-video-by-language/`;
// getAllBlogCategory = `get-all-blog-category/`;
// getBlogByCategory = `get-blog-by-category/`;
// getHomePageIcon = `get-all-business-category/`;
// getClassifiedsBids = `create-free-clasified-bid/`
// ReviewBusiness = `review-business-list/`;
// GetAllStateByCountryId = `get-all-state-by-countryId`;
// GetAllStateByStateId = `get-all-StateName-by-stateId`;
// replyforumcomment = `reply-forum-comment`;

// Auth
export const USER_REGISTER = `register/`;
export const USER_LOGIN = `login/`;
export const VERIFY_EMAIL = `verify-email/`;
export const USER_PROFILE = `get-user-profile/`;
export const FORGET_PASSWORD = `forgot-pass/`;
export const FORGET_PASSWORD_CHANGE = `forgot-password-change/`;
export const CHANGE_PASSWORD = `change-password`;
export const GET_ALL_MY_ADS = `get-free-adsByUserId`;
export const UPDATE_USER_PROFILE = `update-user-profile`;
export const SOCIAL_LOGIN = `google-login`;
export const ACCOUNT_DELETE = `deactivate_acount`;
export const EMAIL_EXISTS = `email-exists`;
export const ADS_SEARCH = `get-search-adsByUserId`;

export const fetchData = async (url, method, data, token, process, res, err, processimg = false) => {
	let elements = document.getElementById("full-page-loader");
	elements.classList.remove("d-none");

	let removeProtocal = ENDPOINT.replace(/^https?:\/\//, "");

	let api_url;

	if (url.includes(removeProtocal)) {
		let removeProtocalFromUrl = url.replace(/^https?:\/\//, "");
		api_url = `https://${removeProtocalFromUrl}`;
	} else {
		api_url = `${ENDPOINT}${url}`;
	}

	let headers = {
		Accept: "application/json",
	};

	if (process) {
		headers = { ...headers, contentType: false, processData: false };
	} else {
		headers = { ...headers, "Content-Type": "application/json" };
	}

	if (token) {
		let TOKEN = localStorage.getItem("__nristoken");
		headers = { ...headers, Authorization: "Bearer " + TOKEN };
	}

	let request = {
		method: method,
		headers: headers,
	};

	if (data) {
		request = { ...request, body: process ? data : JSON.stringify(data) };
	}

	await fetch(api_url, request)
		.then((response) => (processimg === "text" ? response.text() : processimg === "blob" ? response.blob() : response.json()))
		.then((json) => {
			elements.classList.add("d-none");
			if (json.message === "Token is Expired" || json.message === "Token is Invalid") {
				window.$(".modal").modal("hide");
				window.$("#loginModal").modal("show");
				localStorage.removeItem("__nristoken");
				document.getElementById("nrisLogout").click();
			} else {
				res(json);
			}
		})
		.catch((error) => {
			elements.classList.add("d-none");
			console.log(error);
		});
};
